export default __webpack_public_path__ + "static/media/allison_hempenstall.b4900ce8.jpg";